(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-simple"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-style1"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-hulkapps-backup"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

    (()=>{
      const root=document.querySelector('[data-ff-cart]');if(!root)return;
      let timer,running=false,signature='';
      const repair=async()=>{
        const lines=[...root.querySelectorAll('[data-ff-line]')];
        const key=lines.map(e=>e.dataset.ffKey+':'+e.dataset.ffQuantity).join('|');
        if(running||signature===key)return;signature=key;
        if(!lines.some(e=>e.dataset.ffLine==='express'))return;
        running=true;
        try{
          const response=await fetch(root.dataset.ffCartUrl+'.js',{cache:'no-store'});if(!response.ok)return;
          const cart=await response.json();
          const fees=cart.items.filter(i=>i.sku==='UKFF-FOOTBALL-SUPER-EXPRESS');
          const hasFlags=cart.items.some(i=>i.handle==='football-flags'&&i.sku!=='UKFF-FOOTBALL-SUPER-EXPRESS');
          const updates={};fees.forEach((i,index)=>{const quantity=hasFlags&&index===0?1:0;if(i.quantity!==quantity)updates[i.key]=quantity;});
          if(Object.keys(updates).length){const changed=await fetch(root.dataset.ffUpdateUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});if(changed.ok)location.reload();}
        }finally{running=false;}
      };
      const schedule=()=>{clearTimeout(timer);timer=setTimeout(()=>repair().catch(()=>{}),300);};
      new MutationObserver(schedule).observe(root,{childList:true,subtree:true});
      schedule();
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super();
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        vela.swatchProduct();

                        // Update wishlist button status
                        if ('wishlist' in vela && 'updateWishlist' in vela.wishlist) {
                            vela.wishlist.updateWishlist();
                        }

                        $('body').trigger('carousel:init', '.js-recommendations');
                        $('body').trigger('vela:countdown', '[data-countdown]');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            }
        
            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }
    }
    customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewed"] && !Shopify.designMode) return;
  try {
    
    var vela = window.vela || {};
    vela.recentlyViewed = {
        name: 'vela_recently_viewed',
        symbol: '|',
        maximumItems: 10,
        exists: 365,
        products: []
    };

    // Load product handle from cookie
    var cookieRecentlyViewed = vela.getCookie(vela.recentlyViewed.name);
    if (cookieRecentlyViewed !== '') {
        var products = cookieRecentlyViewed.split(vela.recentlyViewed.symbol);
        products.forEach(function(item) {
            vela.recentlyViewed.products.push(item);
        });
    }

    // Add product handle to cookie.
    var pathname = window.location.pathname;
    if (vela && pathname.indexOf('/products/') !== -1) {
        var productHandle = pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        var currentIndex = vela.recentlyViewed.products.indexOf(productHandle);
        if (currentIndex === -1) {
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
            // Only take vela.recentlyViewed.maximumItems items
            vela.recentlyViewed.products = vela.recentlyViewed.products.splice(0, vela.recentlyViewed.maximumItems);
        } else {
            // Remove current handle from array
            vela.recentlyViewed.products.splice(currentIndex, 1);
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
        }

        // Set cookie
        if (vela.recentlyViewed.products.length > 0) {
            var productHandles = vela.recentlyViewed.products.join(vela.recentlyViewed.symbol);
            vela.setCookie(vela.recentlyViewed.name, productHandles, vela.recentlyViewed.exists);
        }
    }

    class ProductRecentlyViewed extends HTMLElement {
        constructor() {
            super();

            this.hiddenClass = 'd-none';
            this.container = this.querySelector('[data-products]');
            this.limit = parseInt(this.dataset.limit, 10);

            if (this.container) {
                this.layout = this.container.dataset.products;

                document.addEventListener("DOMContentLoaded", (event) => {
                    this.initPages();
                });
            }
        }

        initPages() {
            if (vela && vela.recentlyViewed && vela.recentlyViewed.products) {
                if (vela.recentlyViewed.products.length > 1) {
                    this.renderPages();
                } else {
                    this.classList.add(this.hiddenClass);
                }
            } else {
                this.classList.add(this.hiddenClass);
            }
        }

        async renderPages() {
            try {
                let promises = [];
                vela.recentlyViewed.products.forEach((handle, index) => {
                    if (handle && index !== 0 && index <= this.limit) {
                        const url = `${window.Shopify.routes.root}products/${handle}?view=product-card`;
                        promises.push(
                            fetch(url)
                                .then(response => response.text())
                                .then(text => {
                                    if (text && text !== '') {
                                        let productItem = document.createElement('div');
                                        const productItemClass = this.layout === 'grid' ? 'col' : 'slick-carousel__item';
                                        productItem.classList.add(productItemClass);
                                        productItem.innerHTML = text;

                                        return {
                                            element: productItem,
                                            handle: handle,
                                            index: index
                                        };
                                    }
                                })
                                .catch(e => {
                                    console.error(e);
                                })
                        );
                    }
                });

                let data = await Promise.all(promises);
                data.forEach(item => {
                    if ('element' in item) {
                        this.container.append(item.element);
                    }
                });
                this.afterRenderPage();
            } catch (e) {
                console.error(e);
            };
        }

        afterRenderPage() {
            this.classList.remove(this.hiddenClass);
            vela.swatchProduct();

            // Update wishlist button status
            if ('wishlist' in vela && 'updateWishlist' in vela.wishlist) {
                vela.wishlist.updateWishlist();
            }

            if (this.layout === 'carousel') {
                $('body').trigger('carousel:init', '.js-recently-viewed');
            }
            $('body').trigger('vela:countdown', '[data-countdown]');
        }
    }
    customElements.define('product-recently-viewed', ProductRecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ukff-feather-studio"]) return;
  try {
    
(() => {
  const initialise = () => document.querySelectorAll('[data-ff-studio]').forEach((root) => {
    if (root.dataset.ffInitialised) return;
    const variants = JSON.parse(root.querySelector('[data-ff-variants]').textContent);
    const copy = JSON.parse(root.querySelector('[data-ff-copy]').textContent);
    if (!variants.length) return;
    root.dataset.ffInitialised = 'true';
    const money = (amount) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(amount / 100);
    const parse = (v) => {
      const options = v.options || [v.option1, v.option2, v.option3];
      const [print, production] = options[1].split(' — ');
      return { raw: v, size: options[0], print, production, base: options[2] };
    };
    const items = variants.map(parse);
    let selected = items.find((v) => String(v.raw.id) === root.dataset.initialVariant) || items.find((v) => v.raw.available) || items[0];
    let state = { size: selected.size, print: selected.print, production: selected.production, base: selected.base };
    const quantity = root.querySelector('[data-ff-quantity]');
    const variantInput = root.querySelector('[data-ff-variant]');
    const form = variantInput.form;
    form.enctype = 'multipart/form-data';
    const radios = (key) => [...root.querySelectorAll(`[data-ff-${key}]`)];
    const get = (criteria) => items.find((v) => Object.entries(criteria).every(([key, value]) => v[key] === value));
    const bySize = (size) => items.filter((v) => v.size === size);
    const templateNames = { 'Small – 2.8m':'small', 'Medium – 3.4m':'medium', 'Large – 4.5m':'large', 'XL – 5.6m':'xl' };
    const templateUrls = {"small-single": "https://cdn.shopify.com/s/files/1/0923/9203/0581/files/2800singlesided.zip?v=1761652113", "small-double": "https://cdn.shopify.com/s/files/1/0923/9203/0581/files/2800double.zip?v=1761652113", "medium-single": "https://cdn.shopify.com/s/files/1/0923/9203/0581/files/3400single.zip?v=1761708282", "medium-double": "https://cdn.shopify.com/s/files/1/0923/9203/0581/files/3400double.zip?v=1761708286", "large-single": "https://cdn.shopify.com/s/files/1/0923/9203/0581/files/4500single.zip?v=1761709764", "large-double": "https://cdn.shopify.com/s/files/1/0923/9203/0581/files/4500double.zip?v=1761709766", "xl-single": "https://cdn.shopify.com/s/files/1/0923/9203/0581/files/5600single.zip?v=1761711328"};
    const normalise = (changed) => {
      const candidates = bySize(state.size);
      if (!candidates.some((v) => v.print === state.print)) state.print = candidates[0].print;
      if (!candidates.some((v) => v.print === state.print && v.production === state.production)) state.production = candidates.find((v) => v.print === state.print).production;
      if (!get(state)) {
        const candidate = candidates.find((v) => v.print === state.print && v.production === state.production && v.base === 'Single Ground Spike') || candidates.find((v) => v.print === state.print && v.production === state.production) || candidates[0];
        state = { size: candidate.size, print: candidate.print, production: candidate.production, base: candidate.base };
      }
      selected = get(state);
      if (changed) root.querySelector('[data-ff-live]').textContent = copy.configuration_updated;
    };
    const totals = () => {
      const amount = selected.raw.price * (Math.max(1, Number(quantity.value) || 1));
      root.querySelector('[data-ff-total]').textContent = money(amount);
      root.querySelector('[data-ff-mobile-price]').textContent = money(amount);
    };
    const render = () => {
      variantInput.value = selected.raw.id;
      variantInput.disabled = false;
      const available = Boolean(selected.raw.available);
      const button = root.querySelector('[data-ff-add]');
      button.disabled = !available;
      button.firstChild.textContent = (available ? copy.add : copy.unavailable) + ' ';
      ['size','print','base','production'].forEach((key) => radios(key).forEach((input) => {
        input.checked = input.value === state[key];
        if (key === 'print') input.disabled = !bySize(state.size).some((v) => v.print === input.value);
        if (key === 'base') input.closest('[data-ff-base-card]').hidden = !get({ size: state.size, print: state.print, production: state.production, base: input.value });
      }));
      root.querySelector('[data-ff-xl-note]').hidden = state.size !== 'XL – 5.6m';
      root.querySelectorAll('[data-ff-size-price]').forEach((el) => {
        const minimum = Math.min(...bySize(el.dataset.ffSizePrice).map((v) => v.raw.price));
        el.textContent = `${copy.from} ${money(minimum)}`;
      });
      const entry = get({ size: state.size, print: state.print, production: state.production, base:'Single Ground Spike' });
      radios('base').forEach((input) => {
        const item = get({ size: state.size, print: state.print, production: state.production, base:input.value });
        if (!item || !entry) return;
        const delta = item.raw.price - entry.raw.price;
        input.closest('label').querySelector('[data-ff-base-price]').textContent = delta ? `+${money(delta)}` : copy.base_included;
      });
      const standard = get({ size: state.size, print: state.print, production:'Standard (3 Day Production)', base:state.base });
      radios('production').forEach((input) => {
        const item = get({ size: state.size, print: state.print, production:input.value, base:state.base });
        input.disabled = !item;
        const delta = item && standard ? item.raw.price - standard.raw.price : 0;
        input.closest('label').querySelector('[data-ff-production-price]').textContent = delta ? `+${money(delta)}` : copy.base_included;
      });
      root.querySelector('[data-ff-summary]').textContent = [state.size, state.print === 'Single Sided' ? copy.single : copy.double, state.base, state.production].join(' · ');
      root.querySelectorAll('[data-ff-template-size]').forEach((card) => card.classList.toggle('is-selected', card.dataset.ffTemplateSize === state.size));
      const type = state.print === 'Double Sided' ? 'double' : 'single';
      root.querySelector('[data-ff-current-template]').href = templateUrls[`${templateNames[state.size]}-${type}`];
      root.querySelector('[data-ff-current-template-caption]').textContent = `${state.size} · ${type === 'double' ? copy.double : copy.single} · PDF (ZIP)`;
      totals();
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.raw.id);
        if (root.dataset.previewTheme) url.searchParams.set('preview_theme_id', root.dataset.previewTheme);
        window.history.replaceState({}, '', url);
      } catch (_) {}
    };
    ['size','print','base','production'].forEach((key) => radios(key).forEach((input) => input.addEventListener('change', () => {
      state[key] = input.value;
      normalise(key);
      render();
    })));
    quantity.addEventListener('input', totals);
    quantity.addEventListener('change', () => {
      quantity.value = Math.max(1, Math.floor(Number(quantity.value) || 1));
      totals();
    });
    root.querySelector('[data-ff-minus]').addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); totals(); });
    root.querySelector('[data-ff-plus]').addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) || 1) + 1; totals(); });
    form.addEventListener('submit', (event) => {
      if (!selected.raw.available || !form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      variantInput.value = selected.raw.id;
    });
    root.querySelector('[data-ff-fallback]').hidden = true;
    root.querySelector('[data-ff-fallback-select]').disabled = true;
    root.querySelector('[data-ff-enhanced]').hidden = false;
    normalise();
    render();
    const photos = [...root.querySelectorAll('[data-ff-photo]')];
    const hero = root.querySelector('.ff-hero-image');
    const dialog = root.querySelector('[data-ff-dialog]');
    let index = 0;
    const showPhoto = (number) => {
      index = (number + photos.length) % photos.length;
      const photo = photos[index];
      hero.removeAttribute('srcset');
      hero.src = photo.dataset.src;
      hero.alt = photo.dataset.alt;
      photos.forEach((button, i) => button.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
      photos[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
    };
    photos.forEach((button, i) => button.addEventListener('click', () => showPhoto(i)));
    root.querySelector('[data-ff-prev]').addEventListener('click', () => showPhoto(index-1));
    root.querySelector('[data-ff-next]').addEventListener('click', () => showPhoto(index+1));
    root.querySelector('[data-ff-zoom]').addEventListener('click', () => {
      dialog.querySelector('img').src = hero.src;
      dialog.querySelector('img').alt = hero.alt;
      dialog.showModal();
    });
    root.querySelector('[data-ff-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    const observer = new IntersectionObserver((entries) => {
      root.querySelector('[data-ff-mobile-bar]').hidden = entries[0].isIntersecting;
    },{threshold:0.25});
    observer.observe(root.querySelector('[data-ff-add]'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once:true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ukff-football-designer"] && !Shopify.designMode) return;
  try {
    
(() => {
async function buildFootballPdf(spec) {
  const enc = new TextEncoder();
  const bytes = value => typeof value === 'string' ? enc.encode(value) : value;
  const objects = [];
  const reserve = () => { objects.push(null); return objects.length; };
  const add = value => { objects.push(bytes(value)); return objects.length; };
  const join = parts => { const out = new Uint8Array(parts.reduce((n, p) => n + p.length, 0)); let offset = 0; for (const p of parts) { out.set(p, offset); offset += p.length; } return out; };
  const stream = (dictionary, data) => add(join([bytes(`<< ${dictionary} /Length ${data.length} >>\nstream\n`), data, bytes('\nendstream')]));
  const deflate = async data => new Uint8Array(await new Response(new Blob([data]).stream().pipeThrough(new CompressionStream('deflate'))).arrayBuffer());
  const n = value => Number(value.toFixed(6)).toString();
  const literal = value => { let hex = 'FEFF'; for (let i = 0; i < String(value).length; i++) hex += String(value).charCodeAt(i).toString(16).padStart(4, '0'); return `<${hex}>`; };
  const path = data => {
    const tokens = data.match(/[MLQHVZ]|[-+]?(?:\d*\.\d+|\d+\.?\d*)(?:[eE][-+]?\d+)?/g) || [];
    const out = []; let i = 0, cmd = '', x = 0, y = 0, sx = 0, sy = 0;
    while (i < tokens.length) {
      if (/^[A-Z]$/.test(tokens[i])) cmd = tokens[i++];
      const next = () => Number(tokens[i++]);
      if (cmd === 'Z') { out.push('h'); x = sx; y = sy; cmd = ''; }
      else if (cmd === 'M' || cmd === 'L') { x = next(); y = next(); out.push(`${n(x)} ${n(y)} ${cmd === 'M' ? 'm' : 'l'}`); if (cmd === 'M') { sx = x; sy = y; cmd = 'L'; } }
      else if (cmd === 'H') { x = next(); out.push(`${n(x)} ${n(y)} l`); }
      else if (cmd === 'V') { y = next(); out.push(`${n(x)} ${n(y)} l`); }
      else if (cmd === 'Q') { const qx = next(), qy = next(), ex = next(), ey = next(); out.push(`${n(x + (qx - x) * 2 / 3)} ${n(y + (qy - y) * 2 / 3)} ${n(ex + (qx - ex) * 2 / 3)} ${n(ey + (qy - ey) * 2 / 3)} ${n(ex)} ${n(ey)} c`); x = ex; y = ey; }
      else throw new Error('Unsupported outline command');
    }
    return out.join('\n');
  };
  const rgb = hex => [1, 3, 5].map(i => n(parseInt(hex.slice(i, i + 2), 16) / 255)).join(' ');
  const mm = 72 / 25.4, bleed = 20 * mm, w = spec.widthMm * mm, h = spec.heightMm * mm, pw = w + bleed * 2, ph = h + bleed * 2;
  const vh = 1000 * h / w, cross = vh * .18, scale = w / 1000, b = bleed / scale;
  const catalog = reserve(), pages = reserve(), page = reserve();
  const cmds = [`1 1 1 rg 0 0 ${n(pw)} ${n(ph)} re f`, `q ${n(scale)} 0 0 ${n(-scale)} ${n(bleed)} ${n(ph - bleed)} cm`, `${rgb('#c8102e')} rg`, `${n((1000 - cross) / 2)} ${n(-b)} ${n(cross)} ${n(vh + b * 2)} re f`, `${n(-b)} ${n((vh - cross) / 2)} ${n(1000 + b * 2)} ${n(cross)} re f`];
  for (const layer of spec.outlines) {
    cmds.push(`${rgb(layer.fill)} rg`);
    for (const glyph of layer.paths) {
      cmds.push(`q ${glyph.matrix.map(n).join(' ')} cm`, path(glyph.d), 'f Q');
    }
  }
  const imageRefs = [];
  for (const [index, image] of (spec.images || []).entries()) {
    const mask = image.alpha ? stream(`/Type /XObject /Subtype /Image /Width ${image.width} /Height ${image.height} /ColorSpace /DeviceGray /BitsPerComponent 8 /Filter /FlateDecode`, image.alpha) : 0;
    const id = stream(`/Type /XObject /Subtype /Image /Width ${image.width} /Height ${image.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter ${image.filter || '/FlateDecode'}${mask ? ` /SMask ${mask} 0 R` : ''}`, image.data);
    imageRefs.push(`/Im${index} ${id} 0 R`);
    cmds.push(`q ${n(image.drawWidth)} 0 0 ${n(-image.drawHeight)} ${n(image.x)} ${n(image.y + image.drawHeight)} cm /Im${index} Do Q`);
  }
  cmds.push('Q', `q /CutLine CS 1 SCN /CutOverprint gs .25 w ${n(bleed)} ${n(bleed)} ${n(w)} ${n(h)} re S Q`);
  const content = stream('/Filter /FlateDecode', await deflate(bytes(cmds.join('\n'))));
  const manifest = JSON.stringify(spec.metadata, null, 2);
  const attachment = stream('/Type /EmbeddedFile /Subtype /application#2Fjson /Filter /FlateDecode', await deflate(bytes(manifest)));
  const fileSpec = add(`<< /Type /Filespec /F (production-metadata.json) /UF ${literal('production-metadata.json')} /Desc ${literal('Football flag design and production metadata')} /AFRelationship /Data /EF << /F ${attachment} 0 R >> >>`);
  const info = add(`<< /Title ${literal(`${spec.metadata.design_reference} - ${spec.metadata.size} - ${spec.metadata.fabric}`)} /Author ${literal('UK Feather Flags')} /Creator ${literal('UKFF Football designer 2.0')} /Subject ${literal(`Finished ${spec.widthMm} x ${spec.heightMm} mm; 20 mm bleed; CutContour; quantity at submission ${spec.metadata.quantity_at_design_submission}`)} /Keywords ${literal(manifest)} >>`);
  objects[catalog - 1] = bytes(`<< /Type /Catalog /Pages ${pages} 0 R /Names << /EmbeddedFiles << /Names [(production-metadata.json) ${fileSpec} 0 R] >> >> /AF [${fileSpec} 0 R] >>`);
  objects[pages - 1] = bytes(`<< /Type /Pages /Kids [${page} 0 R] /Count 1 >>`);
  objects[page - 1] = bytes(`<< /Type /Page /Parent ${pages} 0 R /MediaBox [0 0 ${n(pw)} ${n(ph)}] /CropBox [0 0 ${n(pw)} ${n(ph)}] /BleedBox [0 0 ${n(pw)} ${n(ph)}] /TrimBox [${n(bleed)} ${n(bleed)} ${n(bleed + w)} ${n(bleed + h)}] /Resources << /ColorSpace << /CutLine [/Separation /CutContour /DeviceCMYK << /FunctionType 2 /Domain [0 1] /C0 [0 0 0 0] /C1 [0 1 0 0] /N 1 >>] >> /ExtGState << /CutOverprint << /Type /ExtGState /OP true /op true /OPM 1 >> >> /XObject << ${imageRefs.join(' ')} >> >> /Contents ${content} 0 R >>`);
  const chunks = [bytes('%PDF-1.7\n%UKFF\n')], offsets = [0]; let position = chunks[0].length;
  objects.forEach((body, index) => { offsets.push(position); const object = join([bytes(`${index + 1} 0 obj\n`), body, bytes('\nendobj\n')]); chunks.push(object); position += object.length; });
  const xref = `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n${offsets.slice(1).map(offset => `${String(offset).padStart(10, '0')} 00000 n \n`).join('')}trailer\n<< /Size ${objects.length + 1} /Root ${catalog} 0 R /Info ${info} 0 R >>\nstartxref\n${position}\n%%EOF\n`;
  chunks.push(bytes(xref));
  return new Blob(chunks, {type:'application/pdf'});
}

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = (s) => root.querySelector(s);
    const form = $('form');
    const variants = JSON.parse($('[data-product-variants]').textContent);
    const labels = JSON.parse($('[data-football-strings]').textContent);
    const svg = $('[data-flag]');
    const size = $('[data-size]');
    const picker = $('[data-logo]');
    const fields = [...root.querySelectorAll('[data-corner]')];
    const add = $('[data-add]');
    const error = $('[data-error]');
    const status = $('[data-file-status]');
    const approved = $('[data-approved]');
    const express=$('[data-production-express]');
    const standard=$('[data-production-standard]');
    const expressId=Number(root.dataset.expressVariant);
    let expressInCart=false;
    const ns = 'http://www.w3.org/2000/svg';
    const colourMap = {Black:'#101820',Navy:'#102c58',Red:'#c8102e'};
    const blockFont=JSON.parse($('[data-football-font]').textContent);
    const tracking=18;
    const lineWidth=(line)=>[...line].reduce((n,c)=>n+(blockFont.glyphs[c]?.a||blockFont.units)+tracking,0)-tracking;
    const money = (p) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:root.dataset.currency||'GBP'}).format(p/100);
    let logo = null, logoData = '', logoFile = null, current, busy = false, sequence = 0;
    const element = (name, attrs, text) => { const e=document.createElementNS(ns,name);Object.entries(attrs).forEach(([k,v])=>{e.setAttribute(k,v);if(k==='href')e.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href',v);});if(text!==undefined)e.textContent=text;return e; };
    const dimensions = () => size.value.match(/[0-9]+(?:\.[0-9]+)?/g).slice(0,2).map(Number);
    const showError = (message) => {error.textContent=message;error.hidden=!message;};
    const quantity = $('[name="quantity"]');
    const makeReference = () => 'FF-' + crypto.randomUUID().toUpperCase();
    let designReference = makeReference(), artifactCache = null, artifactTimer, logoPrint = null, saved = false, cartCheckPromise = null;
    const compressed = async data => new Uint8Array(await new Response(new Blob([data]).stream().pipeThrough(new CompressionStream('deflate'))).arrayBuffer());
    const imageForPdf = async canvas => {
      const ctx = canvas.getContext('2d', {willReadFrequently:true});
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      const rgb = new Uint8Array(canvas.width * canvas.height * 3), alpha = new Uint8Array(canvas.width * canvas.height);
      let transparent = false;
      for (let i = 0, j = 0, k = 0; i < pixels.length; i += 4, j += 3, k++) {
        rgb[j] = pixels[i]; rgb[j + 1] = pixels[i + 1]; rgb[j + 2] = pixels[i + 2]; alpha[k] = pixels[i + 3];
        if (pixels[i + 3] !== 255) transparent = true;
      }
      const [data, mask] = await Promise.all([compressed(rgb), transparent ? compressed(alpha) : null]);
      return {width:canvas.width, height:canvas.height, data, alpha:mask};
    };
    const snapshotMetadata = () => ({
      schema:'ukff.football.production.v2', design_reference:designReference,
      product_id:root.dataset.productId, variant_id:String(current.id), sku:current.sku,
      size:current.option1, fabric:current.option2, finish:'Eyelets', printing:'Single sided',
      finished_width_mm:Math.round(dimensions()[0] * 3048) / 10, finished_height_mm:Math.round(dimensions()[1] * 3048) / 10,
      bleed_mm:20, cut_spot_colour:'CutContour', cut_path:'Finished-size rectangle',
      quantity_at_design_submission:Number(quantity.value), quantity_source:'Shopify order line quantity is authoritative',
      order_reference:'Attached to the Shopify order line after checkout; order number does not exist before checkout',
      text:fields.map(f=>f.value.trim().normalize('NFC').toLocaleUpperCase('en-GB')),
      text_colour:$('[data-colour]').value, logo_height_percent:Number($('[data-logo-size]').value),
      original_logo:logoFile?{name:logoFile.name,width:logo.naturalWidth,height:logo.naturalHeight}:null,
      created_at:new Date().toISOString()
    });
    const prepareProduction = async (snapshot, metadata, printLogo) => {
      const outlines = [...snapshot.querySelectorAll('[data-corner-text]')].map(group=>({
        fill:group.getAttribute('fill'), paths:[...group.querySelectorAll('path')].map(p=>{
          const values = p.getAttribute('transform').match(/[-+]?(?:\d*\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/gi).map(Number);
          return {d:p.getAttribute('d'),matrix:[values[2],0,0,values[3],values[0],values[1]]};
        })
      }));
      const images = [];
      for (const text of snapshot.querySelectorAll('[data-corner-text] text')) {
        const fontSize = Number(text.getAttribute('font-size')), factor = 6;
        const canvas = document.createElement('canvas'), context = canvas.getContext('2d');
        const font = `900 ${fontSize * factor}px "Arial Black", Arial, sans-serif`;
        context.font = font;
        const metrics = context.measureText(text.textContent), pad = 4;
        canvas.width = Math.ceil(metrics.width + pad * 2); canvas.height = Math.ceil(fontSize * factor * 1.5 + pad * 2);
        context.font = font; context.fillStyle = text.parentElement.getAttribute('fill');
        context.fillText(text.textContent, pad, fontSize * factor + pad);
        images.push({...await imageForPdf(canvas),x:Number(text.getAttribute('x')) - pad/factor,y:Number(text.getAttribute('y')) - fontSize - pad/factor,drawWidth:canvas.width/factor,drawHeight:canvas.height/factor});
      }
      const image = snapshot.querySelector('image');
      if (image && printLogo) images.push({...await printLogo,x:Number(image.getAttribute('x')),y:Number(image.getAttribute('y')),drawWidth:Number(image.getAttribute('width')),drawHeight:Number(image.getAttribute('height'))});
      return buildFootballPdf({widthMm:metadata.finished_width_mm,heightMm:metadata.finished_height_mm,outlines,images,metadata});
    };
    const prepareArtifacts = () => {
      const key = JSON.stringify([current?.id,fields.map(f=>f.value),$('[data-colour]').value,$('[data-logo-size]').value,sequence,quantity.value,designReference]);
      if (artifactCache?.key === key) return artifactCache.promise;
      const snapshot = svg.cloneNode(true), metadata = snapshotMetadata(), printLogo = logoPrint;
      const promise = Promise.all([previewBlob(snapshot,600,'image/jpeg'),prepareProduction(snapshot,metadata,printLogo)]).then(([preview,pdf])=>({preview,pdf,metadata}));
      artifactCache = {key,promise};
      promise.catch(()=>{if(artifactCache?.promise===promise)artifactCache=null;});
      return promise;
    };
    const queueArtifacts = () => {
      clearTimeout(artifactTimer);
      artifactTimer = setTimeout(()=>{if(!busy&&current?.available&&quantity.checkValidity())prepareArtifacts().catch(()=>{});},400);
    };
    const invalidateArtifacts = () => {artifactCache=null;designReference=makeReference();saved=false;queueArtifacts();};
    const setSaveStatus = text => {const e=$('[data-save-status]');e.textContent=text;e.hidden=!text;};
    const uploadDesign = batch => new Promise((resolve,reject)=>{
      const request = new XMLHttpRequest();
      request.open('POST',root.dataset.addUrl);request.setRequestHeader('Accept','application/json');request.timeout=120000;
      request.upload.onprogress = event => {if(event.lengthComputable)setSaveStatus(`${labels.uploading} ${Math.min(100,Math.round(event.loaded/event.total*100))}%`);};
      request.upload.onload = () => setSaveStatus(labels.finishing);
      request.onerror = request.ontimeout = () => reject(new Error(labels.cartError));
      request.onload = () => {let result;try{result=JSON.parse(request.responseText);}catch{return reject(new Error(labels.cartError));}if(request.status<200||request.status>=300)reject(new Error(result.description||labels.cartError));else resolve(result);};
      request.send(batch);
    });

    const fitText = (text,x,y,width,height,maxCap) => {
      const capitalText=text.normalize('NFC').toLocaleUpperCase('en-GB');
      const paragraphs=capitalText.split(/\n/);
      let fitted=[];
      let cap=maxCap;
      for(;cap>=4;cap-=1){
        const limit=width*blockFont.cap/cap;
        const lines=[];
        for(const paragraph of paragraphs){
          let line='';
          for(const word of paragraph.split(/\s+/).filter(Boolean)){
            const candidate=line?`${line} ${word}`:word;
            if(line&&lineWidth(candidate)>limit){lines.push(line);line=word;}else line=candidate;
          }
          lines.push(line);
        }
        fitted=lines;
        if(lines.length*cap*1.3<=height&&lines.every(line=>lineWidth(line)<=limit))break;
      }
      cap=Math.max(1,Math.min(cap,...fitted.filter(Boolean).map(line=>width*blockFont.cap/lineWidth(line))));
      const scale=cap/blockFont.cap;
      const group=element('g',{'data-corner-text':capitalText,'aria-label':capitalText,fill:colourMap[$('[data-colour]').value]});
      fitted.forEach((line,index)=>{
        let cursor=x-Math.max(0,lineWidth(line))*scale/2;
        const baseline=y-(fitted.length-1)*cap*1.3/2+index*cap*1.3+cap/2;
        for(const character of line){
          const glyph=blockFont.glyphs[character];
          if(glyph?.d)group.append(element('path',{d:glyph.d,transform:`translate(${cursor} ${baseline}) scale(${scale} ${-scale})`}));
          else if(!glyph)group.append(element('text',{x:cursor,y:baseline,'font-family':'Arial Black, Arial, sans-serif','font-weight':900,'font-size':blockFont.units*scale},character));
          cursor+=((glyph?.a||blockFont.units)+tracking)*scale;
        }
      });
      return group;
    };
    const draw = () => {
      const [w,h]=dimensions(), height=1000*h/w, cross=height*.18;
      svg.setAttribute('viewBox',`0 0 1000 ${height}`);
      svg.replaceChildren(element('rect',{width:1000,height,fill:'#fff'}),element('rect',{x:(1000-cross)/2,y:0,width:cross,height,fill:'#c8102e'}),element('rect',{x:0,y:(height-cross)/2,width:1000,height:cross,fill:'#c8102e'}));
      const panelW=(1000-cross)/2, panelH=(height-cross)/2;
      fields.forEach((f,i)=>{const text=f.value.trim();if(text)svg.append(fitText(text,(i%2?1000-panelW/2:panelW/2),(i>1?height-panelH*.42:panelH*.42),panelW*.82,panelH*.60,height*.17));});
      if(logo){let lh=height*Number($('[data-logo-size]').value)/100,lw=lh*logo.naturalWidth/logo.naturalHeight;if(lw>360){lh*=360/lw;lw=360;}svg.append(element('image',{href:logoData,x:(1000-lw)/2,y:(height-lh)/2,width:lw,height:lh,preserveAspectRatio:'xMidYMid meet'}));}
      const eyelets=element('g',{'data-eyelets':'true'});
      [[18,18],[982,18],[18,height-18],[982,height-18]].forEach(([x,y])=>eyelets.append(element('circle',{cx:x,cy:y,r:8,fill:'#edf3f6',stroke:'#8b9299','stroke-width':4})));
      svg.append(eyelets);
      $('[data-preview-size]').textContent=size.value;
      $('[data-dimensions]').textContent=`${Math.round(w*30.48)} × ${Math.round(h*30.48)} cm`;
    };
    const update = () => {
      current=variants.find(v=>v.option1===size.value&&v.option2===$('[data-material]:checked')?.value);
      $('[data-variant]').value=current?.id||'';
      const unavailable=!current?.available || current.price<=0;
      const count=Math.max(1,Math.min(99,Number(quantity.value)||1));
      const unit=current?.price||0, flagTotal=unit*count;
      const wantsExpress=Boolean(express?.checked), expressPrice=Number(root.dataset.expressPrice)||0;
      const upgrade=wantsExpress&&!expressInCart?expressPrice:0, total=flagTotal+upgrade;
      const inclusive=root.dataset.taxesIncluded==='true', gross=inclusive?total:Math.round(total*1.2);
      $('[data-price]').textContent=unavailable?labels.unavailable:money(gross);
      $('[data-price-note]').textContent=unavailable?'':`${labels.total} · ${labels.incVat}`;
      $('[data-net-price]').textContent=unavailable?'':`${money(inclusive?Math.round(total/1.2):total)} ${labels.exVat} · ${count} × ${money(inclusive?unit:Math.round(unit*1.2))}`;
      add.disabled=unavailable||busy;
      add.textContent=busy?labels.adding:unavailable?labels.unavailable:labels.add;
      $('[data-unavailable]').hidden=!unavailable;
      $('[data-upgrade-total]').hidden=!wantsExpress;
      $('[data-upgrade-total]').textContent=expressInCart?labels.expressAdded:labels.expressIncluded;
      draw();
    };
    const fetchExpressCart=async()=>{
      const response=await fetch(`${root.dataset.cartUrl}.js`,{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error(labels.cartError);
      const basket=await response.json();
      const previouslyInCart=expressInCart;
      expressInCart=basket.items.some(item=>item.variant_id===expressId);
      if(previouslyInCart&&!expressInCart)standard.checked=true;
      if(express){
        standard.disabled=expressInCart;
        express.disabled=expressInCart;
        if(expressInCart)express.checked=true;
        $('[data-express-existing]').hidden=!expressInCart;
        update();
      }
      return basket;
    };
    const checkExpressCart=()=>{
      if(cartCheckPromise)return cartCheckPromise;
      cartCheckPromise=fetchExpressCart().finally(()=>{cartCheckPromise=null;});
      return cartCheckPromise;
    };
    if(express){
      const net=Number(root.dataset.expressPrice)||0;
      $('[data-express-cost]').textContent=money(root.dataset.taxesIncluded==='true'?net:Math.round(net*1.2))+' '+labels.incVat;
      express.addEventListener('change',update);
      standard.addEventListener('change',update);
      checkExpressCart().catch(()=>{});
    }
    const galleryDialog=$('[data-gallery-dialog]');
    let galleryOpener;
    root.querySelectorAll('[data-gallery-image]').forEach(button=>button.addEventListener('click',()=>{
      galleryOpener=button;
      $('[data-gallery-large]').src=button.dataset.src;
      $('[data-gallery-large]').alt=button.dataset.alt;
      galleryDialog.showModal();
    }));
    $('[data-gallery-close]').addEventListener('click',()=>galleryDialog.close());
    galleryDialog.addEventListener('click',event=>{if(event.target===galleryDialog){const b=galleryDialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)galleryDialog.close();}});
    galleryDialog.addEventListener('close',()=>galleryOpener?.focus());
    const edited = () => {approved.checked=false;showError('');update();invalidateArtifacts();};
    quantity.addEventListener('input',()=>{update();invalidateArtifacts();});
    fields.forEach(f=>f.addEventListener('input',edited));
    root.querySelectorAll('[data-material]').forEach(e=>e.addEventListener('change',edited));
    size.addEventListener('change',edited);
    $('[data-colour]').addEventListener('change',edited);
    $('[data-logo-size]').addEventListener('input',edited);
    const clearLogo = () => {sequence++;busy=false;logo=null;logoData='';logoFile=null;logoPrint=null;picker.value='';picker.setCustomValidity('');status.textContent='';$('[data-logo-controls]').hidden=true;edited();};
    $('[data-remove-logo]').addEventListener('click',clearLogo);
    picker.addEventListener('change', async()=>{
      const file=picker.files[0]; if(!file)return;
      clearLogo(); const ticket=++sequence;
      if(!['image/png','image/jpeg','image/webp'].includes(file.type)){showError(labels.typeError);return;}
      if(!file.size||file.size>10*1024*1024){showError(labels.sizeError);return;}
      busy=true;update();
      try{
        const data=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(reader.result);reader.onerror=reject;reader.readAsDataURL(file);});
        const img=new Image();img.src=data;await img.decode();
        if(ticket!==sequence)return;
        if(img.naturalWidth*img.naturalHeight>40000000)throw new Error('image-size');
        const canvas=document.createElement('canvas');const scale=Math.min(1,2000/Math.max(img.naturalWidth,img.naturalHeight));canvas.width=Math.round(img.naturalWidth*scale);canvas.height=Math.round(img.naturalHeight*scale);canvas.getContext('2d').drawImage(img,0,0,canvas.width,canvas.height);
        logoData=canvas.toDataURL('image/png');logo=img;logoFile=file;
        const full=document.createElement('canvas');full.width=img.naturalWidth;full.height=img.naturalHeight;full.getContext('2d').drawImage(img,0,0);
        logoPrint=imageForPdf(full);logoPrint.catch(()=>{});
        status.textContent=`${file.name} · ${img.naturalWidth} × ${img.naturalHeight}px${Math.min(img.naturalWidth,img.naturalHeight)<500?' · '+labels.quality:''}`;
        $('[data-logo-controls]').hidden=false;
      }catch(e){if(ticket===sequence){logo=null;logoData='';logoFile=null;showError(labels.decodeError);}}
      finally{if(ticket===sequence){busy=false;update();invalidateArtifacts();}}
    });
    const getArtwork = (production=false) => {
      const copy=svg.cloneNode(true);copy.removeAttribute('data-flag');copy.removeAttribute('role');copy.removeAttribute('aria-label');
      if(production){copy.querySelector('[data-eyelets]')?.remove();const [w,h]=dimensions();copy.setAttribute('width',`${w*304.8}mm`);copy.setAttribute('height',`${h*304.8}mm`);}else{copy.setAttribute('width','1600');copy.setAttribute('height',String(Math.round(1600*dimensions()[1]/dimensions()[0])));}
      return new XMLSerializer().serializeToString(copy);
    };
    const previewBlob = async(snapshot=svg.cloneNode(true),width=1600,type='image/png') => {
      const box=snapshot.getAttribute('viewBox').split(/\s+/).map(Number),height=Math.round(width*box[3]/box[2]);
      snapshot.setAttribute('width',String(width));snapshot.setAttribute('height',String(height));
      const source=new Blob([new XMLSerializer().serializeToString(snapshot)],{type:'image/svg+xml;charset=utf-8'}),url=URL.createObjectURL(source);
      try{const img=new Image();img.src=url;await img.decode();const canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;const ctx=canvas.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,width,height);ctx.drawImage(img,0,0,width,height);return await new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(new Error(labels.exportError)),type,.86));}finally{URL.revokeObjectURL(url);}
    };
    $('[data-download]').addEventListener('click',async()=>{try{const blob=await previewBlob(),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='my-football-flag-preview.png';a.click();setTimeout(()=>URL.revokeObjectURL(url),30000);}catch(e){showError(labels.exportError);}});
    form.addEventListener('submit',async event=>{
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||!current?.available||current.price<=0)return;
      if(!fields.some(f=>f.value.trim())&&!logoFile){showError(labels.empty);fields[0].focus();return;}
      if(!form.reportValidity())return;
      busy=true;showError('');setSaveStatus(labels.preparing);update();
      form.setAttribute('aria-busy','true');form.inert=true;
      try{
        const artifactsTask=prepareArtifacts();
        const addDesign=async()=>{
          const [artifacts,basket]=await Promise.all([artifactsTask,checkExpressCart()]);
          if(basket.items.some(item=>item.properties?.['Design reference']===artifacts.metadata.design_reference))return;
          const data=new FormData(form);
          fields.forEach(f=>data.set(f.name,f.value.trim().normalize('NFC').toLocaleUpperCase('en-GB')));
          data.delete('form_type');data.delete('utf8');data.delete('properties[Original football logo]');
          for(const key of [...data.keys()])if(key.startsWith('ff-material-')||key.startsWith('ff-production-'))data.delete(key);
          if(!logoFile)data.delete('properties[Logo height (% of flag)]');
          const m=artifacts.metadata;
          data.set('properties[Design reference]',m.design_reference);
          data.set('properties[Fabric]',m.fabric);data.set('properties[Flag size]',m.size);
          data.set('properties[Finished size]',`${m.finished_width_mm} × ${m.finished_height_mm} mm`);
          data.set('properties[_Production metadata]',JSON.stringify(m));
          const slug=`${m.design_reference}_${m.size.replace(/\s+/g,'')}_${m.fabric.includes('220')?'220gsm':'115gsm'}`;
          data.set('properties[Design preview]',artifacts.preview,`${slug}_preview.jpg`);
          data.set('properties[Print PDF]',artifacts.pdf,`${slug}_20mm-bleed_CutContour.pdf`);
          const batch=new FormData();
          for(const [key,value] of data.entries()){
            const nested=key.startsWith('properties[')?`items[0][properties]${key.slice(10)}`:`items[0][${key}]`;
            if(value instanceof File)batch.append(nested,value,value.name);else batch.append(nested,value);
          }
          if(express?.checked&&!expressInCart&&expressId){batch.append('items[1][id]',String(expressId));batch.append('items[1][quantity]','1');}
          await uploadDesign(batch);
        };
        if(navigator.locks)await navigator.locks.request('ukff-football-cart',addDesign);else await addDesign();
        saved=true;location.assign(root.dataset.cartUrl);
      }catch(e){showError(e.message||labels.cartError);busy=false;form.inert=false;form.removeAttribute('aria-busy');setSaveStatus('');update();}
    },true);
    window.addEventListener('pageshow',()=>{busy=false;form.inert=false;form.removeAttribute('aria-busy');setSaveStatus('');if(saved)invalidateArtifacts();update();if(express)checkExpressCart().catch(()=>{});});
    update();queueArtifacts();
  };
  const initialise=()=>document.querySelectorAll('[data-football-designer]').forEach(init);
  initialise();document.addEventListener('shopify:section:load',initialise);
})();

  } catch(e) { console.error(e); }
})();
})();
